
import { useSelector } from "@/core/redux/store";
import calculateHeights from "./calculate-heights";
import WaveSingle from "./wave-single";
import { useMemo } from "react";
import { Skeleton } from "@/shared/components/ui/skeleton";
import { formatNumber } from "../../processed-sources/processed-sources";

const mockData = [
  {
    name: "Tersine Müh.",
    value: 973,
    bgColor: "#4ADE80",
  },
  {
    name: "Yapay Zeka",
    value: 686,
    bgColor: "#22C55E",
  },
  {
    name: "Şablonlar",
    value: 383,
    bgColor: "#16A34A",
  },
  {
    name: "İçe aktarım",
    value: 172,
    bgColor: "#15803D",
  },
  {
    name: "Manuel",
    value: 45,
    bgColor: "#166534",
  },
];

const bgColors = ["#4ADE80", "#22C55E", "#16A34A", "#15803D", "#166534"];
const itemSourceName = {
  "ai": "Yapay Zeka",
  "reversed_engineering": "Tersine Müh.",
  "manual": "Manuel",
  "merging": "İçe aktarım",
  "template": "Şablonlar",
}


export default function WavesChart({ data }: { data: { itemSource: string; value: number; }[] }) {
  const isLoading = useSelector((state) => state.dashboard.loadingSpecificationItemSources);
  const calculatedHeights = useMemo(
    () => {
      if (isLoading || !data.length) {
        return calculateHeights(mockData.map((item, index) => ({
          name: item.name,
          value: 0,
          bgColor: item.bgColor,
        })));
      }
      return calculateHeights(data.sort((a, b) => b.value - a.value).map((item, index) => ({
        name: itemSourceName[item.itemSource as keyof typeof itemSourceName] ?? item.itemSource,
        value: item.value,
        bgColor: bgColors[index],
      })))
    },
    [data, isLoading]
  );
  return (
    <div className="flex h-full">
      {calculatedHeights.map(
        ({ name, value, bgColor, diffHeight, heightTotal }, index) => {
          return (
            <div
              key={`waves-chart-${index}`}
              className="flex-1 flex flex-col justify-between border-r border-border"
            >
              <div className="pt-[16px] px-[20px]">
                <div className="text-[14px] text-muted-foreground font-600">
                  {isLoading ? <Skeleton className="w-[60px] h-[14px] mt-[4px]" /> : name}
                </div>
                <div className="text-[20px] font-[Inter] font-[800] text-black mt-[4px]">
                  {isLoading ? <Skeleton className="w-[60px] h-[20px] mt-[4px]" /> : formatNumber(value)}
                </div>
              </div>
              <div className="mt-auto">
                <WaveSingle
                  diffHeight={diffHeight}
                  heightTotal={heightTotal}
                  bgColor={isLoading ? "#E4E4E7" : bgColor}
                />
              </div>
            </div>
          );
        }
      )}
    </div>
  );
}
